module.exports = require("proxy-agent-negotiate");